export default __webpack_public_path__ + "static/vida-park-ef12e6f23fe7280e2cffd5e9ff3d274d.jpg";